class AgentConfig {
	maxStoredSessions: number | null = null;
	maxEphemeralSessions = 1000;
	maxSteps: number | null = null;
	emptyResponseRetries = 3;
	transientErrorRetries = 3;
	transientRetryBaseDelayMs = 1_000;
	compactionTriggerPercent = 90;
	compactionTailUserCharsBudget = 20_000;
	toolPreviewMaxChars = 8_000;
	toolPayloadMaxTokens = 10_000;
	charsPerTokenEstimate = 3;
	readMaxChars = 60_000;
	navigationDepthDefault = 2;
	searchHitsDefault = 15;
	searchHitsMax = 100;
	searchQueryMaxChars = 500;
	searchScanDeadlineMs = 30_000;
	searchCatalogsMaxMatchesPerHit = 2;
	searchCatalogsMaxMatchesLimit = 50;
	searchFilesMaxMatchesDefault = 1;
	searchFilesMaxMatchesLimit = 3;
	searchMatchLineMaxChars = 320;
	searchTimeoutMs = 120_000;
	searchIndexProgressWaitMs = 300_000;
	repoExcludedPathPatterns = [/(^|\/)\.git(\/|$)/i];
	systemPrefix = "@system";
	skillPrefix = "@skills";
	attachmentPrefix = "@attachments";
	resourcePrefix = "@resources";
	secretsSettingsHref = "@settings/keys-passwords";
	skillsDirectory = "agent/skills";
	maxAttachments = 10;
	maxDownloadMb = 100;
	get maxDownloadBytes() {
		return this.maxDownloadMb * 1024 * 1024;
	}
	maxImageAttachmentMb = 50;
	get maxImageAttachmentBytes() {
		return this.maxImageAttachmentMb * 1024 * 1024;
	}
	maxRecognizeImages = 10;
	httpRequestTimeoutMs = 120_000;
	imageAttachmentExtensions = ["png", "jpg", "jpeg", "gif", "webp", "svg"];
	spreadsheetAttachmentExtensions = ["xlsx", "xlsm", "xltx", "xltm", "xls", "xlsb"];
	convertibleAttachmentExtensions = ["pdf", "docx", ...this.spreadsheetAttachmentExtensions];
	binaryAttachmentExtensions = [
		"mp3",
		"wav",
		"m4a",
		"flac",
		"ogg",
		"opus",
		"mp4",
		"mov",
		"avi",
		"mkv",
		"pptx",
		"ppt",
		"doc",
		"odt",
		"ods",
		"zip",
		"bin",
		"wasm",
	];
	allowedAttachmentExtensions = [
		"txt",
		"md",
		"markdown",
		"json",
		"xml",
		"yaml",
		"yml",
		"csv",
		"html",
		"htm",
		"log",
		"ts",
		"tsx",
		"js",
		"jsx",
		"css",
		"sql",
		"ini",
		"toml",
		...this.imageAttachmentExtensions,
		...this.convertibleAttachmentExtensions,
		...this.binaryAttachmentExtensions,
	];
}

export const agentConfig = new AgentConfig();
